/* ==========================================================================
   Dropdayz — vaste koopbalk op de productpagina. 27 augustus 2026.
   Auditpunt 1, tweede helft. De eerste helft (aanloop inkorten) staat in
   assets/ddz-pdp-vouw.css.

   WAAROM DEZE BALK BESTAAT

   Met de kortere aanloop staat de koopknop op y=602 in plaats van y=695. Op
   de meeste laptops is dat binnen beeld, maar op een klein scherm en op een
   telefoon (waar eerst een hele foto boven staat) niet. Deze balk schuift in
   zodra de echte knop uit beeld scrolt en verdwijnt weer zodra hij terug in
   beeld is. Standaard bij END, SNS en Zalando.

   HET BELANGRIJKSTE ONTWERPBESLUIT: DEZE BALK VOEGT NIETS ZELF TOE.

   De knop in de balk doet niets anders dan de ECHTE koopknop aanklikken.
   Geen tweede fetch naar /cart/add, geen eigen variant-logica, geen kopie van
   de maatkeuze. Alles wat er al werkt — de maatladder, de winkelwagenla, de
   aanvraagmodus, de uitverkocht-afhandeling — blijft dus vanzelf werken, ook
   als daar later iets aan verandert. Bouw hier nooit een eigen toevoeg-route
   in; dan heb je twee waarheden en gaan ze uit elkaar lopen.

   GEEN IntersectionObserver EN GEEN requestAnimationFrame. DAT IS BEWUST.

   Eerste versie gebruikte IntersectionObserver. Nagemeten in een tabblad met
   document.visibilityState === "hidden": de callback vuurde 0 keer in 1,4 s,
   precies zoals rAF daar 0 keer vuurt. Een bezoeker met de pagina open in een
   achtergrondtab die daarna terugklikt, zou de balk dan nooit zien. Een
   scroll-listener met een getBoundingClientRect op één element werkt overal,
   kost verwaarloosbaar veel, en is bovendien te testen. Zet dit niet terug.

   WAAR DE GEGEVENS VANDAAN KOMEN (allemaal nagemeten in de DOM)

     naam    .product-single__title
     prijs   .product__price — met een regex op het eerste €-bedrag. De
             tekstinhoud van dat element is "€130,00 €130,00 Sale Uitverkocht"
             omdat er verborgen labels voor schermlezers in staan. Niet
             textContent gebruiken zonder die regex.
     maat    select[name="id"] → selectedOptions[0].text, bv "EU 39 - US 6.5".
             Dat is de enige echte bron: de maatvakjes zetten die select.
     foto    meerdere selectors, want de galerij levert de afbeelding soms pas
             na het laden aan (lazy loading). Zie fotoBron(): als er bij het
             opbouwen nog geen bron is, wordt hij bij window.load alsnog
             ingevuld. Geen foto is geen ramp — de balk werkt dan gewoon zonder.

   VIER DINGEN DIE MOETEN BLIJVEN WERKEN — niet weghalen:

   1. De balk spiegelt de staat van de echte knop (uitgeschakeld, andere
      tekst). Bij een uitverkochte maat zet ddz-pdp-maatladder.liquid de knop
      op disabled met de tekst "Maat X is uitverkocht"; die tekst hoort dan
      ook hier te staan, anders belooft de balk iets wat niet kan.
   2. Tijdens een maataanvraag (body.ddz-in-aanvraag) is kopen uitgeschakeld.
      Zelfde verhaal.
   3. Als de winkelwagenla openstaat verdwijnt de balk. Anders staan er twee
      zwarte vlakken over elkaar en is niet duidelijk welke knop wat doet.
   4. De balk verschijnt pas als de echte knop UIT beeld is. Nooit allebei
      tegelijk zichtbaar.
   ========================================================================== */
(function () {
  'use strict';

  if (!document.body || document.body.className.indexOf('template-product') === -1) { return; }

  var form = document.querySelector('form[action*="/cart/add"]');
  if (!form) { return; }

  var echteKnop = form.querySelector('[type="submit"]');
  if (!echteKnop) { return; }

  var titelEl = document.querySelector('.product-single__title');
  var prijsEl = document.querySelector('.product__price');
  var maatSel = form.querySelector('[name="id"]');
  var overlay = document.querySelector('.ddz-cart-overlay');

  function tekst(el) { return el ? (el.textContent || '').replace(/\s+/g, ' ').trim() : ''; }

  function prijs() {
    // zie kop: textContent bevat ook verborgen labels. Alleen het eerste bedrag.
    var m = tekst(prijsEl).match(/€\s?[\d.,]+/);
    return m ? m[0] : '';
  }

  function maat() {
    if (maatSel && maatSel.selectedOptions && maatSel.selectedOptions.length) {
      return maatSel.selectedOptions[0].text || '';
    }
    return '';
  }

  /* de galerij levert de foto soms pas na het laden — meerdere kansen pakken */
  function fotoBron() {
    var kandidaten = document.querySelectorAll(
      'img.product-featured, .product-single__photo img, .product-single__photos img, .feature-row__image'
    );
    for (var i = 0; i < kandidaten.length; i++) {
      var el = kandidaten[i];
      var bron = el.currentSrc || el.getAttribute('src') || el.getAttribute('data-src') || '';
      if (bron && bron.indexOf('data:') !== 0) { return bron; }
    }
    return '';
  }

  /* ---------- de balk bouwen ---------- */
  var balk = document.createElement('div');
  balk.className = 'ddz-koopbalk';
  balk.setAttribute('hidden', '');
  balk.innerHTML =
    '<div class="ddz-koopbalk__in">' +
      '<img class="ddz-koopbalk__foto" alt="" aria-hidden="true" hidden>' +
      '<div class="ddz-koopbalk__tekst">' +
        '<div class="ddz-koopbalk__naam"></div>' +
        '<div class="ddz-koopbalk__maat"></div>' +
      '</div>' +
      '<div class="ddz-koopbalk__prijs"></div>' +
      '<button type="button" class="ddz-koopbalk__knop"></button>' +
    '</div>';

  document.body.appendChild(balk);

  var naamEl = balk.querySelector('.ddz-koopbalk__naam');
  var maatEl = balk.querySelector('.ddz-koopbalk__maat');
  var prijsB = balk.querySelector('.ddz-koopbalk__prijs');
  var knopEl = balk.querySelector('.ddz-koopbalk__knop');
  var fotoB  = balk.querySelector('.ddz-koopbalk__foto');

  naamEl.textContent = tekst(titelEl);

  function zetFoto() {
    var bron = fotoBron();
    if (bron) { fotoB.src = bron; fotoB.removeAttribute('hidden'); }
  }
  zetFoto();
  window.addEventListener('load', zetFoto);

  /* ---------- balk gelijkhouden met de echte knop ---------- */
  function ververs() {
    prijsB.textContent = prijs();

    var m = maat();
    maatEl.textContent = m ? ('Maat ' + m) : 'Kies eerst een maat';

    // punt 1 en 2 uit de kop: staat van de echte knop overnemen
    var inAanvraag = document.body.classList.contains('ddz-in-aanvraag');
    knopEl.disabled = echteKnop.disabled || inAanvraag;

    var knopTekst = tekst(echteKnop);
    if (inAanvraag) {
      knopEl.textContent = 'Aanvraag loopt';
    } else if (echteKnop.disabled && knopTekst) {
      knopEl.textContent = knopTekst;         // bv "Maat 42 is uitverkocht"
    } else {
      knopEl.textContent = 'Toevoegen';
    }
  }

  ververs();

  /* ---------- de knop klikt de ECHTE knop aan ---------- */
  knopEl.addEventListener('click', function () {
    if (knopEl.disabled) { return; }
    echteKnop.click();
  });

  /* ---------- zichtbaarheid ---------- */
  var knopInBeeld = true;

  function toon() {
    var laOpen = overlay && !overlay.hasAttribute('hidden');
    var mag = !knopInBeeld && !laOpen;

    if (mag) {
      balk.removeAttribute('hidden');
      // in een aparte tick, anders slaat de transitie over
      setTimeout(function () { balk.classList.add('is-zichtbaar'); }, 10);
    } else {
      balk.classList.remove('is-zichtbaar');
      setTimeout(function () {
        if (!balk.classList.contains('is-zichtbaar')) { balk.setAttribute('hidden', ''); }
      }, 260);
    }
  }

  function meet() {
    var r = echteKnop.getBoundingClientRect();
    var hoogte = window.innerHeight || document.documentElement.clientHeight;
    var nu = r.bottom > 0 && r.top < hoogte;
    if (nu !== knopInBeeld) { knopInBeeld = nu; toon(); }
  }

  /* eenvoudige throttle op 80 ms, met een natrap zodat de laatste positie
     altijd meegenomen wordt. Geen rAF — zie de kop. */
  var bezig = false, natrap = null;
  function opScroll() {
    if (bezig) {
      clearTimeout(natrap);
      natrap = setTimeout(function () { bezig = false; opScroll(); }, 90);
      return;
    }
    bezig = true;
    meet();
    setTimeout(function () { bezig = false; }, 80);
  }

  window.addEventListener('scroll', opScroll, { passive: true });
  window.addEventListener('resize', meet);
  meet();

  /* ---------- meebewegen met de rest van de pagina ---------- */
  if (maatSel) { maatSel.addEventListener('change', ververs); }

  // de maatvakjes zetten de select; even wachten tot dat gebeurd is
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('.ddz-size-box')) {
      setTimeout(ververs, 60);
    }
  });

  if ('MutationObserver' in window) {
    // punt 1 en 2: de echte knop kan van tekst of staat veranderen
    new MutationObserver(ververs).observe(echteKnop, {
      attributes: true, childList: true, characterData: true, subtree: true
    });
    new MutationObserver(ververs).observe(document.body, {
      attributes: true, attributeFilter: ['class']
    });
    // punt 3: la open of dicht
    if (overlay) {
      new MutationObserver(toon).observe(overlay, {
        attributes: true, attributeFilter: ['hidden']
      });
    }
  }
}());
